export default __webpack_public_path__ + "static/media/countSq.e5f35c29.jpg";